<!-- <app-header></app-header> -->
<div class="container main-layout">
<!-- <app-sidebar-chatbot></app-sidebar-chatbot> -->
    <div class="assign-container fluid-container">
        <div class="top-row wrap-header">
            <div class="left-titl-buton ">
                <div class="back-button" (click)="redirectToAssignScenario()">
                    &larr;
                </div>
                <div class="title">
                    Assign {{this.config.RolePlay.DisplayText}}
                </div>
            </div>
            <div class="right-filter">
                <input matInput #searchInput placeholder="Search user..." class="filter-search" (input)="applyFilter(searchInput.value)">
                <i class="fa fa-search search-icon"></i>
            </div>
            <div *ngIf="showNoSearchResultsMessage">
                No search results found.
            </div>
        </div>
        <div class="bottom-table">
            <div class="overflowxauto">
                <table class="assignee-table mat-elevation-z8" mat-table [dataSource]="dataSource" matSort
                    (matSortChange)="sortData($event)">
                    <ng-container matColumnDef="select">
                        <th mat-header-cell *matHeaderCellDef>
                            <mat-checkbox (change)="$event ? toggleAllRows() : null" [checked]="selection.hasValue() && isAllSelected()"
                                [indeterminate]="selection.hasValue() && !isAllSelected()">
                            </mat-checkbox>
                        </th>                        
                        <td mat-cell *matCellDef="let row">
                            <mat-checkbox 
                                (click)="$event.stopPropagation()" 
                                (change)="onCheckboxChange(row)"
                                [checked]="isRowSelected(row)"
                                [disabled]="isRoleplayCompleted(row)">
                            </mat-checkbox>
                        </td>
                      </ng-container>
                    <ng-container matColumnDef="wwid">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by number"
                            class="tab-th">
                            WWID
                        </th>
                        <td mat-cell *matCellDef="let element" class="tab-td"> {{element.wwid}} </td>
                    </ng-container>
                    <!-- <ng-container matColumnDef="avtar_enabled">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by number"
                            class="tab-th">
                            Avatar
                        </th>
                        <td mat-cell *matCellDef="let element">
                            <div class="button-dev2">
                                <mat-slide-toggle [(ngModel)]="element.avtar_enabled" (change)="toggle(element.wwid)"></mat-slide-toggle>
                            </div>
                          </td>
                    </ng-container> -->
                    
                    <ng-container matColumnDef="first_name">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by number"
                            class="tab-th">
                            First Name
                        </th>
                        <td mat-cell *matCellDef="let element" class="tab-td"> {{element.first_name}} </td>
                    </ng-container>

                    <ng-container matColumnDef="last_name">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by number"
                            class="tab-th">
                            Last Name
                        </th>
                        <td mat-cell *matCellDef="let element" class="tab-td"> {{element.last_name}} </td>
                    </ng-container>

                    <ng-container matColumnDef="assigned_date">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by number"
                            class="tab-th">
                            Date of Assign
                        </th>
                        <td mat-cell *matCellDef="let element" class="tab-td"> {{element.assigned_date}} </td>
                    </ng-container>

                    <ng-container matColumnDef="assigned_status">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by number"
                            class="tab-th">
                            Assign Status
                        </th>
                        <td mat-cell *matCellDef="let element" class="tab-td"> {{element.assigned_status}} </td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

                </table>
                <mat-paginator [pageSizeOptions]="[5, 10, 15, 20]" showFirstLastButtons
                    aria-label="Select page of periodic elements">
                </mat-paginator>
            </div>
            <div class="sub-but-div"> <button (click)="submit()" class="sub-but">Submit</button></div>
        </div>
    </div>
</div>
